import { Dealer, useDealer } from './useDealer';
import { useMemo } from 'react';
import { hoeffnerUrl, kraftUrl, mahlerUrl } from '../env';

type Dimensions = { width: number; height: number };

export const useUrls = (): {
  logo: string;
  logoDimensions: Dimensions;
  supportDimensions?: Dimensions;
  support: string;
  shopUrl: string;
  saveUrl: string;
  saveParam: 'id' | 'code';
  restartUrl: string;
  hotline?: string;
} => {
  const dealer: Dealer = useDealer();

  return useMemo(() => {
    const base = {
      logo: `https://oc-k3.s3.eu-central-1.amazonaws.com/assets/static/schrankwerk-tisch/${dealer}.svg`,
      support: `https://oc-k3.s3.eu-central-1.amazonaws.com/assets/static/schrankwerk-tisch/${dealer}-support.svg`,
    };

    switch (dealer) {
      case 'kraft':
        return {
          ...base,
          logoDimensions: { width: 262, height: 56 },
          shopUrl: kraftUrl + '/kraftwerk',
          saveUrl: kraftUrl + '/ext/konfigurator2',
          saveParam: 'id',
          restartUrl: kraftUrl + '/kraftwerk/modellauswahl',
          hotline: '0800 3522-222',
        };
      case 'mahler':
        return {
          ...base,
          logoDimensions: { width: 262, height: 56 },
          shopUrl: mahlerUrl,
          saveUrl:
            'https://konfigurator2.moebel-mahler-siebenlehn.de/v1/frontend',
          saveParam: 'code',
          restartUrl: mahlerUrl + '/masswerk/modellauswahl',
        };
      case 'scontode':
        return {
          ...base,
          logoDimensions: { width: 262, height: 56 },
          shopUrl: 'https://www.sconto.de/masswerk',
          saveUrl: 'https://www.sconto.de/ext/konfigurator2',
          saveParam: 'id',
          restartUrl: 'https://www.sconto.de/masswerk/modellauswahl',
          hotline: '030 677982-296',
        };
      case 'DMK':
        return {
          ...base,
          logoDimensions: { width: 262, height: 56 },
          shopUrl: 'https://www.dickmaenken.de/',
          saveUrl: 'https://www.dickmaenken.de/konfigurator2',
          saveParam: 'id',
          restartUrl: 'https://www.dickmaenken.de/modellauswahl',
        };
      case 'schrankwerkde':
        return {
          ...base,
          logoDimensions: { width: 215, height: 35 },
          supportDimensions: { width: 282, height: 42 },
          shopUrl: 'https://www.schrankwerk.de/',
          saveUrl: 'https://www.schrankwerk.de/ext/konfigurator2',
          saveParam: 'id',
          restartUrl: 'https://www.schrankwerk.de/produkte',
          hotline: '030 634183-380',
        };
      case 'hoeffner':
      default:
        return {
          ...base,
          logoDimensions: { width: 262, height: 56 },
          shopUrl: hoeffnerUrl + '/moebelwerke',
          saveUrl: hoeffnerUrl + '/ext/konfigurator2',
          saveParam: 'id',
          restartUrl: hoeffnerUrl + '/moebelwerke/modellauswahl',
          hotline: '030 374449-338',
        };
    }
  }, [dealer]);
};
